import type { ReactNode } from 'react'

// Пустое состояние списка: заголовок и пояснение, что сделать, чтобы список
// перестал быть пустым.
export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="empty">
      <b>{title}</b>
      {children}
    </div>
  )
}
